// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_HabilitausuarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for habilitaUsuario() /usuarios/habilitaUsuario
 * Returns bool (true) on successful user enable via auth-service.
 * Proxy to auth-service /user/habilitaUsuario/{username}.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_HabilitausuarioResponseDados = boolean;

export type Usuarios_HabilitausuarioResponse = ApiResponse<Usuarios_HabilitausuarioResponseDados>;

registerResponseContract('Usuarios_HabilitausuarioResponse', {})
